import { css } from '@emotion/core';
import Link from 'next/link';
import React from 'react';

import Divider from '@/src/shared/components/Divider';
import Heading from '@/src/shared/components/Heading';
import { bp, colors } from '@/styles';

const styles = {
  divider: css`
    margin: 0;
    @media print {
      display: none;
    }
  `,
  memberHeader: css`
    font-size: 28px;
    line-height: 36px;
    margin: 20px 0 16px;
    @media ${bp.md} {
      font-size: 36px;
      margin: 24px 0 30px;
    }
  `,
  linkItem: css`
    display: block;
    color: ${colors.primaryBlue};
    font-size: 1.6rem;
    line-height: 3.2rem;
    font-weight: 900;
  `,
  committeesRow: css`
    display: none;
    @media ${bp.xl} {
      display: block;
      margin-bottom: 16px;
    }
  `,
  committeesCol: css`
    display: block;
    margin-bottom: 32px;
    @media ${bp.xl} {
      display: none;
      margin-bottom: 0;
    }
  `,
};

const YourCommittees = ({ column, committees }) => (
  <section css={column ? styles.committeesCol : styles.committeesRow}>
    <Divider type="red" css={styles.divider} />
    <Heading type={1} css={styles.memberHeader} theme="primaryGray" weight="bolder">
      My Committees
    </Heading>
    {committees.map(({ CommitteeName, CommitteeCode }) => (
      <Link
        key={CommitteeCode}
        href="/policy/committees/[slug]"
        as={`/policy/committees/${CommitteeCode}`}
        passHref
      >
        <a css={styles.linkItem}>{CommitteeName}</a>
      </Link>
    ))}
  </section>
);

export default YourCommittees;
